'use es6';

export function openAuthWindow(authURL) {
  return window.open(authURL, 'window', 'toolbar=no, menubar=no, resizable=yes, height=850, width=775');
}
export function formatAdWordsAccountId(accountId) {
  // Format like AdWords as "123-456-7890"
  const id = accountId.toString();
  return `${id.substring(0, 3)}-${id.substring(3, 6)}-${id.substring(6)}`;
}
/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking

if (!!module && !!module.exports) {
  module.exports.default = Object.assign({}, module.exports);
}

export function openFBAuthWindow(loginURL) {
  window.open(loginURL, 'window', 'toolbar=no, menubar=no, resizable=yes, height=850, width=775');
}